import Pdf from '@static/images/icons/pdf.svg';
import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const PdfIcon = styled(Pdf)`
  height: 14px;
`;
export const DocumentContainer = styled.p`
  border-top: 1px solid var(--border-soft);
  padding: 16px 0px;
  margin-top: 16px;
  color: var(--text-soft);
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Evidence = styled.span`
  ${typographyV2.titleSm}
`;

export const CitationLink = styled.a`
  ${typographyV2.uiXs};
  color: var(--text-primary);
  background: var(--surface-warning);
  padding: 0 4px;
  border-radius: 2px;
  min-width: 16px;
  display: inline-block;
  text-align: center;

  &:hover {
    color: var(--text-primary);
    text-decoration: underline;
  }
`;

export const DocumentLink = styled.a`
  ${typographyV2.bodyXs};
  color: var(--text-primary);
  background: var(--surface-default);
  display: flex;
  align-items: center;
  border-radius: 4px;
  gap: 4px;
  padding: 4px 8px 4px 0;

  &:hover {
    color: var(--text-primary);
    background: var(--surface-hover);
  }
`;

export const Citation = styled.span`
  min-width: 16px;
  text-align: center;
  ${typographyV2.bodySm}
`;

export const Filename = styled.span`
  ${typographyV2.bodyXs}
`;
